import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { store } from "./redux-store";
import ReactGA from "react-ga";
import  i18n from './i18n';
import { I18nextProvider } from "react-i18next";
import { CustomToastProvider } from "./components/customtoast/CustomToastProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
let persistor = persistStore(store);

ReactGA.initialize("G-MBN0HYJW9S");

root.render(
  <React.StrictMode>
    <I18nextProvider  i18n={i18n}>
        <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
          <CustomToastProvider>
            <App />
          </CustomToastProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </I18nextProvider>  
  </React.StrictMode>

);
